import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// Initialize Firebase
// During build, environment variables may not be available.
// Make sure to set them in App Hosting backend settings.
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize Firebase services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);

// Typed Firestore helpers
import { 
  CollectionReference, 
  DocumentReference, 
  collection, 
  doc 
} from 'firebase/firestore';

/**
 * Get a typed collection reference
 */
export function colRef<T>(path: string): CollectionReference<T> {
  return collection(db, path) as CollectionReference<T>;
}

/**
 * Get a typed document reference
 */
export function docRef<T>(path: string, ...pathSegments: string[]): DocumentReference<T> {
  return doc(db, path, ...pathSegments) as DocumentReference<T>;
}
